/* eslint-disable import/no-webpack-loader-syntax */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import english from "./en.json";
import german from "./de.json";
import french from "./fr.json";

const resources = {
  en: {translation: english},
  de: {translation: german},
  fr: {translation: french}
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
export const t = i18n.t;